// extracted by mini-css-extract-plugin
export default {"loading":"k0PBIO","picture":"WHYTv2"};